var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#282828",
    fillRule: "evenodd",
    d: "M11 22.5c.828 0 1.5-.674 1.5-1.501H14C14 22.654 12.654 24 11 24s-3-1.346-3-3.001h1.5c0 .827.672 1.501 1.5 1.501zm9.815-6.806c.654.624.862 1.566.527 2.401-.34.853-1.162 1.405-2.092 1.405H2.75c-.93 0-1.751-.551-2.092-1.404-.335-.836-.128-1.778.527-2.402 1.31-1.248 2.313-2.554 2.313-6.98 0-3.73 2.971-6.773 6.752-7.14V.75c0-.414.336-.75.75-.75s.75.336.75.75v.823c3.78.368 6.752 3.41 6.752 7.141 0 4.426 1.002 5.732 2.313 6.98zM19.25 18c.664 0 1.002-.77.53-1.22-1.643-1.564-2.778-3.315-2.778-8.066C17.002 5.556 14.317 3 11 3 7.683 3 4.998 5.556 4.998 8.715c0 4.769-1.145 6.51-2.779 8.066-.47.447-.136 1.219.531 1.219h16.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.97af73043aa673efd703e14f68b635bc.svg";
export { ForwardRef as ReactComponent };